<template>
  <div id="upload-stock-request-page">
    <div class="flex gap-1 flex-wrap items-center mb-5">
      <router-link class="flex" :to="`/${$route.params.lang}/merchant/dashboard`">
        <feather-icon svgClasses="w-5" icon="HomeIcon"></feather-icon>
      </router-link>
      <div class="flex items-center gap-1">
        <feather-icon svgClasses="w-4" icon="ChevronsRightIcon"></feather-icon>
        <router-link class="flex" :to="{ name: listRouteName }">
          <p class="leading-none capitalize">{{ $t(listTitle) }}</p>
        </router-link>
      </div>
      <div class="flex items-center gap-1">
        <feather-icon svgClasses="w-4" icon="ChevronsRightIcon"></feather-icon>
        <p class="leading-none font-medium">{{ $t(uploadTitle) }}</p>
      </div>
    </div>

    <input type="file" class="hidden" ref="fileInput" accept=".xlsx, .xls" @change="handleClick">

    <div class="upload-file-border text-center p-4" :class="fillManualFlag ? 'lg:flex items-center justify-between' : ''">
      <div :class="fillManualFlag ? 'lg:flex items-center gap-6' : ''">
        <img src="../../../assets/images/pages/upload-orders-logo.svg" height="50" width="80"/>
        <div
          @click="$refs.fileInput.click()"
          @drop="handleDrop"
          @dragover="handleDragover"
          @dragenter="handleDragover"
          class="cursor-pointer text-base text-center">
          <div class="pb-2 text-sm font-semibold">
            <div class="flex items-center gap-2 justify-center">
              <feather-icon icon="UploadCloudIcon" svgClasses="h-8 w-8 text-blue-100"/>
              <p>
                <span class="font-semibold text-primary" @click.stop="$refs.fileInput.click()">{{ $t('Click To Upload') + ' ' }}</span>
                <span class="text-black font-semibold">{{ $t(dropText) }}</span>
              </p>
            </div>
            <p class="text-darkgray font-semibold">{{ $t('Supports files of .xls and .xlsx formats') }}</p>
          </div>
        </div>
      </div>
      <div class="mt-2">
        <div class="flex items-center justify-center gap-2">
          <vs-button class="p-0 font-semibold text-sm" @click="uploadStockRequestModal = true, mixPanelActivate('STOCK_UPLOAD_V2_UPLOAD_FILE')">
            <div class="flex gap-2 items-center py-2 px-3">
              <p>{{ $t('Upload File') }}</p>
              <p class="material-icons-outlined text-xl">upload_file</p>
            </div>
          </vs-button>
          <vs-button class="p-0 font-semibold text-sm">
            <div class="flex gap-2 items-center py-2 px-3" @click="fillManual(), mixPanelActivate('STOCK_UPLOAD_V2_FILL_MANUALLY')">
              <p>{{ $t('Fill Manually') }}</p>
              <p class="material-icons-outlined text-xl">touch_app</p>
            </div>
          </vs-button>
        </div>
      </div>
    </div>

    <div v-for="(fileDetail, index) in fileDetails" :key="index" class="upload-file-box p-3 w-full mt-5">
      <div class="flex items-center justify-between">
        <div class="flex items-center justify-between">
          <div class="rounded-full p-1 h-12 w-12 flex items-center justify-center" style="background: #EDF4FB;">
            <feather-icon icon="FileTextIcon" svgClasses="h-6 w-6" style="color:#1C5BFE;"/>
          </div>
          <div class="ml-2">
            <p class="text-lg font-medium"> {{ fileDetail.data ? fileDetail.data.name : '' }} </p>
            <p class="text-sm font-medium text-grey"> {{ fileDetail.data ? fileDetail.data.size / 1000 : '' }} KB</p>
          </div>
        </div>
        <div class="flex items-center gap-6">
          <div :class="fileActionsDisabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'" @click="replaceFile(fileDetail)">
            <div class="upload-action flex px-3 py-2" :class="fileActionsDisabled ? 'disabled-action' : ''">
              <feather-icon icon="RepeatIcon" svgClasses="w-4 h-4" class="self-center"/>
              <span class="text-sm ml-2">{{ $t('Replace File') }}</span>
            </div>
          </div>
          <div :class="fileActionsDisabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'" @click="deleteFile(fileDetail)">
            <div class="upload-action-delete flex px-2 py-2" :class="fileActionsDisabled ? 'disabled-action' : ''">
              <feather-icon icon="Trash2Icon" svgClasses="w-5 h-5" class="self-center text-red"/>
            </div>
          </div>
        </div>
      </div>
    </div>

    <stock-request-draft-table
      :replacedFile="replacedFile" @replacedFile="replacedFile = $event"
      :fillManualPressed="fillManualPressed"
      :merchant="merchant" :userMerchant="userMerchant"
      :fillManualFlag="fillManualFlag"
      :originFile="originFile"
      :deletedFile="deletedFile" @deletedFile="deletedFile = $event"
      :uploadFileFlag="uploadFileFlag"
      :fileDetails="fileDetails" @fileDetails="fileDetails = $event"
      @deleteFile="deleteFile"
      @submitSucceeded="fileActionsDisabled = true"
      :uploadType="uploadType">
    </stock-request-draft-table>

    <upload-stock-request-modal
      :uploadStockRequestModal="uploadStockRequestModal" @uploadStockRequestModal="uploadStockRequestModal = $event"
      @uploaded="handleModalUpload"
      :uploadType="uploadType">
    </upload-stock-request-modal>
  </div>
</template>

<script>
import StockRequestDraftTable from './components/StockRequestDraftTable.vue'
import UploadStockRequestModal from './components/UploadStockRequestModal.vue'
import common from '../../../assets/utils/common'

export default {
  props: {
    uploadType: {
      type: String,
      default: 'stock-request'
    }
  },
  data () {
    return {
      uploadStockRequestModal: false,
      fillManualFlag: false,
      fileDetails: [],
      originFile: {},
      uploadFileFlag: false,
      fillManualPressed: false,
      deletedFile: '',
      replacedFile: '',
      uploadSequence: 0,
      fileActionsDisabled: false,
      userMerchant: {},
      merchant: {},
      releaseVersion: process.env.VUE_APP_RELEASE_VERSION
    }
  },
  computed: {
    isStockRecall () {
      return this.uploadType === 'stock-recall'
    },
    uploadTitle () {
      return this.isStockRecall ? 'Upload Stock Recall' : 'Upload Stock Request'
    },
    listTitle () {
      return this.isStockRecall ? 'Stock Recalls' : 'Stock Requests'
    },
    listRouteName () {
      return this.isStockRecall ? 'merchant-fulfillment-stock-recalls' : 'merchant-fulfillment-stock-requests'
    },
    dropText () {
      return this.isStockRecall ? 'or drag and drop your stock recall sheet' : 'or drag and drop your stock request sheet'
    }
  },
  methods: {
    resetInputloader () {
      this.$refs.fileInput.value = ''
    },
    fillManual () {
      this.fillManualPressed = true
      this.fillManualFlag = true
    },
    addFile (rawFile) {
      this.uploadSequence += 1
      const fileDetail = {
        id: `${Date.now()}-${this.uploadSequence}`,
        data: rawFile
      }
      this.fileDetails.push(fileDetail)
      this.originFile = fileDetail
      this.uploadFileFlag = !this.uploadFileFlag
      this.fillManualFlag = true
      this.resetInputloader()
    },
    handleClick (e) {
      const files = e.target.files
      if (e.target.files.length) {
        const rawFile = files[0]
        if (!rawFile) return
        if (!this.isExcel(rawFile)) {
          this.$vs.notify({
            title: this.$t('Warning'),
            text: this.$t('Only supports upload .xlsx, .xls suffix files'),
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning'
          })
          this.resetInputloader()
          return false
        }
        this.addFile(rawFile)
      }
    },
    handleDragover (e) {
      e.stopPropagation()
      e.preventDefault()
      e.dataTransfer.dropEffect = 'copy'
    },
    handleDrop (e) {
      e.stopPropagation()
      e.preventDefault()
      const files = e.dataTransfer.files
      if (files.length !== 1) {
        this.$vs.notify({
          title: this.$t('Warning'),
          text: this.$t('Only support uploading one file!'),
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })
        return
      }
      const rawFile = files[0]
      if (!this.isExcel(rawFile)) {
        this.$vs.notify({
          title: this.$t('Warning'),
          text: this.$t('Only supports upload .xlsx, .xls suffix files'),
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })
        return false
      }
      this.addFile(rawFile)
    },
    isExcel (file) {
      return /\.(xlsx|xls)$/i.test(file.name)
    },
    handleModalUpload (rawFile) {
      this.addFile(rawFile)
    },
    deleteFile (fileDetail) {
      if (this.fileActionsDisabled) return
      this.deletedFile = fileDetail.id || null
      for (let i = this.fileDetails.length - 1; i >= 0; --i) {
        if (this.fileDetails[i].id === this.deletedFile) {
          this.fileDetails.splice(i, 1)
          if (this.fileDetails.length === i) this.resetInputloader()
        }
      }
      this.mixPanelActivate('STOCK_UPLOAD_V2_DELETE_FILE')
    },
    replaceFile (fileDetail) {
      if (this.fileActionsDisabled) return
      this.replacedFile = fileDetail
      this.$refs.fileInput.click()
      this.mixPanelActivate('STOCK_UPLOAD_V2_REPLACE_FILE')
    },
    mixPanelActivate (type) {
      if (this.releaseVersion !== 'staging') {
        this.$mixpanel.track(type, {
          merchant_name: this.merchant.name,
          merchant_email: this.userMerchant.email,
          source: /(android)/i.test(navigator.userAgent)
        })
      }
    }
  },
  components: {
    StockRequestDraftTable,
    UploadStockRequestModal
  },
  created () {
    const merchantData = common.checkMerchantInLocalStorage(this)
    merchantData.then(results => {
      this.merchant = results.merchantData
      this.userMerchant = results.userMerchantData
    })
  }
}
</script>

<style lang="scss">
.upload-file-border {
  background: #EDF4FB;
  border-radius: 14px !important;
  border: 2px dashed rgba(28, 91, 254, 0.26) !important;
}
.upload-file-box {
  background: #fff;
  border-radius: 8px !important;
  border: 2px solid #CBE4FD !important;
}
.upload-file {
  background: #EDF4FB;
}
.upload-action {
  font-weight: 500;
  background: #fff;
  border-radius: 6px;
  color: #1C5BFE;
  box-shadow: 0px 2px 8px rgba(10, 50, 102, 0.32);
}
.upload-action-delete {
  font-weight: 500;
  background: #fff;
  border-radius: 6px;
  color: #D21C1C;
  box-shadow: 0px 2px 8px rgba(10, 50, 102, 0.32);
  border: 2px solid #D21C1C !important;
}
.disabled-action {
  pointer-events: none;
}
</style>
